import LegalPage from './LegalPage'

export default function Polityka() {
  return <LegalPage tab="polityka" />
}
